import {
    useMemo,
} from 'react'

import {
    Navigate,
} from 'react-router-dom'
import {
    SkyNetRouteConfigObject, useSkyNetRoutes,
} from 'app/SkyNetRoutes'
import {
    CommonRoutes,
} from 'app/enums/common.enums'
import {
    FinanceDomains,
} from 'app/enums/domain.enums'
import useFinanceRoutes from 'app/SkyNetRoutes/hooks/useFinanceRoutes'
import FxRates from './FxRates'
import Invoices from './Invoices'

export default function Finance() {
    const Routes = useFinanceRoutes()
    const routesConfig: SkyNetRouteConfigObject<FinanceDomains> = useMemo(() => {
        return {
            [Routes.Invoices.route]: <Invoices />,
            [Routes.FxRates.route]: <FxRates />,
            [CommonRoutes.Slash]: <Navigate
                to={Routes.Invoices.route}
                replace
            />,
        }
    }, [Routes])

    return useSkyNetRoutes({
        routesConfig,
    })
}
